var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"promotion"},[(_vm.isLoading)?_c('div',[_vm._v("생성 및 저장 중...")]):_c('div',[_vm._v("완료")])])
}
var staticRenderFns = []

export { render, staticRenderFns }